export const Spinner = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`spinner relative w-[0.875rem] h-[0.875rem] ${className}`}>
      <div className="absolute inset-0 rounded-full border-[0.188rem] border-white/50" />
      <div className="absolute inset-0 rounded-full border-[0.16rem] border-t-white border-b-transparent border-l-transparent border-r-transparent animate-spin-slow" />
    </div>
  );
};
